import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../../../common/components/interactions/interactions';
import '../../../common/components/color/color';
import '../../../common/components/typography/typography';
import css from './link.css';

const Link = ({ href, className, children, type, ...otherProps }) => (
  <a
    href={href}
    className={classnames(
      {
        [css['eiu-link']]: type === 'default',
        [css['eiu-custom-link']]: type === 'custom',
      },
      className,
    )}
    {...otherProps}
  >
    {children}
  </a>
);

Link.defaultProps = {
  className: '',
  children: null,
  type: 'default',
};

Link.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default Link;
